import * as React from 'react';
import { Notification } from '../../components/Notification';
import { getTextCount } from '../../utils/folders';
import { FolderName } from '../../components/Notification/FolderName';
import { useSelector } from 'react-redux';
import { selectSavedInFolders, selectSavedOfferId, selectUserHasFolders } from '../../selectors';
import { CreateFolderButtonContainer } from '../CreateFolderButtonContainer';
import { ChangeFolderButtonContainer } from '../ChangeFolderButtonContainer';
var FAVORITES_URL = 'https://cian.ru/favorites';
export function NotificationContainer(_ref) {
  var linkOpenMode = _ref.linkOpenMode,
    isAuthenticated = _ref.isAuthenticated,
    onClickName = _ref.onClickName,
    onHide = _ref.onHide,
    _ref$onWaitForLogin = _ref.onWaitForLogin,
    onWaitForLogin = _ref$onWaitForLogin === void 0 ? function () {} : _ref$onWaitForLogin,
    onSaveToFolder = _ref.onSaveToFolder,
    onChangeFolder = _ref.onChangeFolder;
  // eslint-disable-next-line
  var timer = React.useRef(null);
  var isClientMobile = document.documentElement.clientWidth <= 320;
  var offerIds = useSelector(selectSavedOfferId);
  var savedInFolders = useSelector(selectSavedInFolders);
  var userHasFolders = useSelector(selectUserHasFolders);
  var handleNotAuthenticatedSaveToFolder = React.useCallback(function () {
    onSaveToFolder();
    onWaitForLogin();
  }, [onWaitForLogin, onSaveToFolder]);
  var button;
  if (!isAuthenticated) {
    button = /*#__PURE__*/React.createElement("button", {
      onClick: handleNotAuthenticatedSaveToFolder
    }, "\u0421\u043E\u0445\u0440. \u0432 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0443");
  } else if (offerIds.length <= 1 && !savedInFolders && !userHasFolders) {
    button = /*#__PURE__*/React.createElement(CreateFolderButtonContainer, {
      showIcon: false
    });
  } else if (offerIds.length <= 1) {
    button = /*#__PURE__*/React.createElement(ChangeFolderButtonContainer, {
      showIcon: false,
      onChangeFolder: onChangeFolder,
      onSaveToFolder: onSaveToFolder
    });
  }
  var createTimeout = function createTimeout() {
    timer.current = setTimeout(function () {
      onHide();
    }, 7000);
  };
  React.useEffect(function () {
    createTimeout();
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  var handleClickName = function handleClickName() {
    if (savedInFolders) {
      onClickName(savedInFolders[0].id);
    }
  };
  var description;
  if (savedInFolders && savedInFolders.length === 0) {
    description = /*#__PURE__*/React.createElement("div", null, isClientMobile ? 'Удалено из подборок' : 'Объявление удалено из всех подборок');
  } else if (!savedInFolders) {
    description = /*#__PURE__*/React.createElement("div", null, isClientMobile ? 'В избранном' : 'Добавлено в избранное');
  } else {
    var spanText = savedInFolders.length > 1 ? getTextCount(savedInFolders.length) : "\xAB".concat(savedInFolders[0].name, "\xBB");
    description = /*#__PURE__*/React.createElement("div", null, "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E \u0432", /*#__PURE__*/React.createElement(FolderName, {
      linkOpenMode: linkOpenMode,
      folderUrl: savedInFolders && savedInFolders.length === 1 ? "".concat(FAVORITES_URL, "?folder=").concat(savedInFolders[0].id) : '',
      text: spanText,
      onClick: handleClickName
    }));
  }
  var handleMouseMove = function handleMouseMove() {
    if (timer.current) {
      clearTimeout(timer.current);
      createTimeout();
    }
  };
  return /*#__PURE__*/React.createElement(Notification, {
    description: description,
    button: button,
    onMouseMove: handleMouseMove
  });
}